import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointDown } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { RatingDeclarations } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingDeclarations/index.js';
import { GroupContainer } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingGroups/components/GroupContainer.js';
import { RatingGroupsLoadingState } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingGroups/components/LoadingState.js';
import { ScoreBar } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/ScoreBar.js';
import { AMADEUSREVIEW_CATEGORY_PRIORITY } from '../../../../../../components/HotelDetailsOverlay/models.js';
import { HeadlineMedium, HelpTooltip, LabelMedium, LabelSmall, Tooltip, Flex } from '../../../../../../primitives/index.js';
import { HOTEL_DETAILS_QA_ID, qaId } from '../../../../../../utils/qaId.js';
export const RatingGroups = ({
  loading,
  groups
}) => {
  const {
    t
  } = useTranslation();
  const mdDown = useBreakpointDown('md');
  const smDown = useBreakpointDown('sm');
  const categories = useMemo(() => {
    if (!groups) {
      return [];
    }
    return AMADEUSREVIEW_CATEGORY_PRIORITY.filter(key => groups[key] !== 0).map(key => ({
      key,
      value: groups[key]
    }));
  }, [groups]);
  return _jsxs(Flex, {
    children: [_jsxs(Flex, {
      direction: "row",
      alignItems: "center",
      spacing: "8px",
      children: [_jsx(HeadlineMedium, {
        "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'amadeusratingsection-headline'),
        children: t('hotelDetailsOverlay:amadeusRatingSection.groupsTitle')
      }), mdDown && _jsx(HelpTooltip, {
        tooltipText: t('hotelDetailsOverlay:amadeusRatingSection.score.tooltipTitle'),
        placement: "bottom",
        content: _jsx(RatingDeclarations, {})
      })]
    }), loading ? _jsx(RatingGroupsLoadingState, {}) : _jsx(GroupContainer, {
      children: categories.map(({
        key,
        value
      }) => {
        return smDown ? _jsxs(Flex, {
          spacing: "4px",
          children: [_jsx(LabelSmall, {
            children: t(`hotelDetailsOverlay:amadeusRatingSection.groups.${key}`)
          }), _jsx(ScoreBar, {
            rating: value
          })]
        }, key) : _jsxs(Flex, {
          spacing: "4px",
          children: [_jsx(LabelMedium, {
            children: t(`hotelDetailsOverlay:amadeusRatingSection.groups.${key}`)
          }), mdDown ? _jsx(ScoreBar, {
            rating: value
          }) : _jsx(Tooltip, {
            tooltipText: t(`hotelDetailsOverlay:amadeusRatingSection.groups.${key}`),
            tooltipElement: "AmaRatingScoreBar",
            content: _jsx(RatingDeclarations, {}),
            children: _jsx(ScoreBar, {
              rating: value
            })
          })]
        }, key);
      })
    })]
  });
};